import { LOCK_CONTENT, UNLOCK_CONTENT } from '../../../global-state/redux/constants';

const adminVM2Role = 'manage_admin_user_role|MEV-App-VM2-Admin';
const adminRole = 'manage_admin_user_role|Admin';
const soRole = 'manage_admin_user_role|MEV-APP-VM2-SO';
export const adminRoles = [adminVM2Role, adminRole, soRole];
// Key & values to storage + text to show
export const layers = 'Layers';
export const layerStorageKey = 'layer';
export const storageValueDesktop = 'VMX';
export const classValueDesktop = 'Desktop';
export const storageValueApp = 'App';
export const storageValueTerminal = 'Terminal';
export const addLayerPrefix = (val) => `layer${val}`;
export const buttonsArr = [
  {
    redux: UNLOCK_CONTENT, showWhenContentUnlocked: false, label: 'Content-Locked', icon: <i className="fa-solid fa-lock" />
  },
  {
    redux: LOCK_CONTENT, showWhenContentUnlocked: true, label: 'Content-Unlocked', icon: <i className="fa-solid fa-unlock" />
  },
  { storage: storageValueApp, label: storageValueApp, icon: <i className="fa-solid fa-mobile-retro" /> },
  { storage: storageValueTerminal, label: storageValueTerminal, icon: <i className="fa-solid fa-desktop" /> },
  { storage: storageValueDesktop, label: classValueDesktop, icon: <i className="fa-solid fa-computer" /> }
];
